var map = {
	"./angular.svg": "9368",
	"./aws.svg": "2bdc",
	"./cSharp.svg": "4ef8",
	"./dot-net-core.svg": "88a0",
	"./python.png": "b1b6",
	"./python.svg": "cddc",
	"./react.svg": "1a22",
	"./ruby-on-rails.svg": "aba6",
	"./vue.svg": "4ad0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ea56";